type MarkerBasedInstructionProps = {
  markerThumbnail: string;
};
const MarkerBasedInstruction = ({
  markerThumbnail,
}: MarkerBasedInstructionProps) => {
  return (
    <div
      className="absolute top-0 bottom-0 left-0 h-full w-full"
      id="instruction_screen"
    >
      <img
        src="https://rhym.s3.ap-south-1.amazonaws.com/AR/markerbased/markerbased-inst.png"
        className="h-full w-full absolute top-0 left-0 object-cover"
        alt=""
      />
      <img
        src={markerThumbnail}
        className="absolute inset-0 m-auto h-[19vh] w-[34vw] object-contain"
        alt=""
      />
      <div className="body-2 text-white absolute top-[65%] inset-x-0 mx-auto text-center">
        Point Camera at this image
      </div>
      <div className="absolute top-[80%] inset-x-0 mx-auto text-center">
        <div className="body-1 text-white">Powered by Vizaro</div>
      </div>
    </div>
  );
};

export default MarkerBasedInstruction;
